/// <reference path="../../../../typings/index.d.ts" />
///<reference path="smart-mover/smart-mover.module.ts"/>
///<reference path="hideInput/hideInput.module.ts"/>


module Meevo.Components.Controls {
  'use strict';

  angular.module('meevo.components.controls', [
    'meevo.components.controls.SmartMover',
    'meevo.components.controls.HideInput'
  ]);
}
